import { HubConnectionBuilder } from '@microsoft/signalr';
import HUB_BASE_URL from '@redux/sagas/settings/hubbaseurl';
import * as alerts from '@redux/utils/alerts';
import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';

const useBandwidthControl = (
  videoPlayerState: boolean,
  handleBandwidthExceeded: () => void
): {
  data: any;
  state: any;
  sendBandwidthRequest: (payload: number) => void;
} => {
  const intl = useIntl();
  const [data, setData] = useState<any[]>([]);
  const [connection, setConnection] = useState<any>(null);
  const [state, setState] = useState<any>(null);

  const connect = () => {
    if (connection) {
      connection.onreconnected(() => {
        setState(connection.state);
      });
      connection.onreconnecting(() => setState(connection.state));
      connection.onclose(() => setState(connection.state));
      connection
        .start()
        .then((result) => {
          setState(connection.state);
          // Register the event handler for receiving messages
          connection.on('ReceiveUsageAlerts', onReceiveUsageAlerts);
        })
        .catch((e) => {});
    }
  };

  const onReceiveUsageAlerts = (incomingData) => {
    try {
      switch (incomingData.alertType) {
        case 1:
          setData(incomingData);
          break;
        case 2:
            alerts.showErrorAlertFailChangesToast({
            error: {
                errorMessage: intl.formatMessage({
                id: 'units.videoPlayer.bandwidthExceeded'
              })
            }
          });
        handleBandwidthExceeded();
          break;
      }
    } catch (e) {
      console.log('Error', e);
    }
  };
  const sendBandwidthRequest = (payload: number) => {
    if (connection) {
      connection.invoke('CheckBandwidthUsage', payload);
    }
  };

  useEffect(() => {
    if (connection) setState(connection.state);
  }, [connection?.state]);

  useEffect(() => {
    connect();
    return () => connection?.stop();
  }, [connection]);

  useEffect(() => {
    if (!videoPlayerState) {
      if (connection) {
        connection.stop();
        setConnection(null);
      }
      setData([]);
      return;
    }
    const token = localStorage.getItem('auth');
    const newConnection = new HubConnectionBuilder()
      .withUrl(`${HUB_BASE_URL}?serviceName=${encodeURIComponent("videoPlayer")}`, {accessTokenFactory: () => token || ''})
      .withAutomaticReconnect()
      .build();

    setConnection(newConnection);
  }, [videoPlayerState]);

  return {
    data,
    state,
    sendBandwidthRequest
  };
};

export default useBandwidthControl;
